import { I18n } from '@affine/i18n';
import { registerTableTranslator } from '@blocksuite/affine/blocks/table';

const TABLE_I18N_PREFIX = 'com.streamlain.table.';

registerTableTranslator(key => {
  const fullKey = `${TABLE_I18N_PREFIX}${key}`;
  const translate = (I18n as unknown as Record<string, () => string>)[fullKey];
  if (typeof translate !== 'function') {
    return undefined;
  }

  const translated = translate();
  return translated === fullKey ? undefined : translated;
});
